import { DefinitionName, type Manifest, type v4 } from '@sap/ux-specification-types';
import { description, isViewNode, syncRule, validity } from '../../../common/decoration/decorators';
import { addPatternForBindingChangeOfEnumLR } from '../../../common/decoration/control';
import { getHeaderActionsPath } from '../../application';
import { addEnumForActionAnchor, addHeaderFooterCustomActionDefinition } from '../../utils';
import type { DecoratorContext } from '../../../common/decoration/interfaces';

/**
 * Sync class for Position
 */
export class CustomHeaderActionPosition implements v4.CustomHeaderActionPosition {
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey: string): string =>
                getHeaderActionsPath(pageName, manifest, sectionId, columnKey) + '/position'
        }
    })
    @validity({
        since: '1.84.0'
    })
    anchor?: string;
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey: string): string =>
                getHeaderActionsPath(pageName, manifest, sectionId, columnKey) + '/position'
        }
    })
    @validity({
        since: '1.84.0'
    })
    placement: v4.ActionPlacement;
}

@isViewNode
@description('Custom Action')
export class CustomHeaderAction implements v4.CustomHeaderAction {
    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    text: string;

    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    position: CustomHeaderActionPosition;

    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        }
    })
    @validity({
        since: '1.84.0'
    })
    press: string;

    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        },
        generate: addPatternForBindingChangeOfEnumLR
    })
    @validity({
        since: '1.84.0'
    })
    visible?: boolean;

    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        },
        generate: addPatternForBindingChangeOfEnumLR
    })
    @validity({
        since: '1.84.0'
    })
    enabled?: boolean;

    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        }
    })
    @validity({
        since: '1.142.0'
    })
    overflowGroup?: number;

    @syncRule({
        manifest: {
            path: getHeaderActionsPath
        }
    })
    @validity({
        since: '1.139.0'
    })
    priority?: v4.ActionPriority;

    /**
     * Called automatically by Decorator.apply() after all decorator steps.
     * Adds custom action definitions and anchor enums to the schema.
     *
     * @param context - The decorator context providing schema, page target, and logger
     */
    init(context: DecoratorContext) {
        addHeaderFooterCustomActionDefinition(
            context.schema.get(),
            context.page?.target,
            context.logger,
            'CustomHeaderAction' as DefinitionName,
            DefinitionName.HeaderActions
        );
        addEnumForActionAnchor(
            context.schema.get(),
            DefinitionName.HeaderActions,
            DefinitionName.CustomHeaderActionPosition
        );
    }
}
